/** @jsxImportSource theme-ui */
import { useEffect, useState } from "react";
import { Box, Button as _ThemeUiButton } from "theme-ui";
import { motion, AnimatePresence } from "framer-motion";
import FocusLock from "react-focus-lock";
import debounce from "lodash/debounce";

import * as styles from "./ModalCenterEnlarged.styles";

export default function ModalCenterEnlarged({
  isTopMostModal,
  onClose = () => {},
  children,
  disableEscapeKey = false,
  background,
  boxShadow,
  modalContainerStyles,
  modalBottom,
}) {
  const [isOpened, setIsOpened] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const close = () => setIsVisible(false);

  useEffect(() => {
    function handleKeyDown(e) {
      if (e.key === "Escape" && isTopMostModal & !disableEscapeKey) {
        close();
      }
    }

    const handleKeyDownDebounced = debounce(handleKeyDown);

    document.addEventListener("keydown", handleKeyDownDebounced);

    return () => {
      document.removeEventListener("keydown", handleKeyDownDebounced);
    };
  }, [isTopMostModal]);

  return (
    <AnimatePresence>
      {isVisible && (
        <FocusLock returnFocus disabled={!isOpened}>
          <motion.div
            sx={styles.modalContainer({ modalContainerStyles })}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            onAnimationComplete={(definition) => {
              if (definition.opacity === 1) {
                setIsOpened(true);
              }
              if (definition.opacity === 0) {
                onClose();
              }
            }}
          >
            <Box
              sx={styles.centeredBox({
                background,
                boxShadow,
                modalBottom,
              })}
            >
              {typeof children === "function"
                ? children({
                    close,
                  })
                : children}
            </Box>
          </motion.div>
        </FocusLock>
      )}
    </AnimatePresence>
  );
}
